var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBag = function SvgBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bag_svg__Lager_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.17 18.39"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bag_svg__cls-1{fill:none;stroke:#1d1d1b;stroke-miterlimit:10;stroke-width:.7px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bag_svg__Lager_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bag_svg__Rectangle_3295",
    className: "bag_svg__cls-1",
    d: "M.35 2.86h13.47v15.18H.35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bag_svg__Path_37767",
    className: "bag_svg__cls-1",
    d: "M4 5C4 4 4 .35 6.92.35S9.83 4 9.83 5"
  }))));
};
export default SvgBag;